<template>
  <HeaderLayout color='#0018F0'>
    <template v-slot:center>
      <div style="width: 100%; max-width: 383px">
        <HeaderSearchFieldContainer :items="searchTargetList" />
      </div>
    </template>
    <template v-slot:right>
      <div class="mr-2">
        <SmallIconButton
          icon="mdi-lightning-bolt"
          @click="() => $router.push({ name: 'writerSystemInformations' })"
        />
      </div>
      <div class="mr-2">
        <SmallIconButton
          icon="mdi-help-circle-outline"
          @click="toSupportPage"
        />
      </div>
      <AccountMenuContainer>
        <router-link to="/writers/profiles">
          <ProfileListItem />
        </router-link>
        <router-link to="/writers/emails">
          <EmailListItem />
        </router-link>
        <router-link to="/writers/passwords">
          <PasswordListItem />
        </router-link>
      </AccountMenuContainer>
    </template>
  </HeaderLayout>
</template>

<script>
import SmallIconButton from '/src/components/uiParts/buttons/SmallIconButton'
import AccountMenuContainer from '/src/container/shared/Header/AccountMenuContainer'
import ProfileListItem from '/src/components/uiParts/ListItems/Profile'
import EmailListItem from '/src/components/uiParts/ListItems/Email'
import PasswordListItem from '/src/components/uiParts/ListItems/Password'
import { pageNameMapper } from '@/src/routers/writer'
import HeaderSearchFieldContainer from '/src/container/shared/Header/HeaderSearchFieldContainer'
import HeaderLayout from '/src/components/shared/HeaderLayout'

export default {
  name: 'WriterHeader',
  components: {
    HeaderLayout,
    HeaderSearchFieldContainer,
    PasswordListItem,
    EmailListItem,
    ProfileListItem,
    AccountMenuContainer,
    SmallIconButton
  },
  props: {
    color: {
      type: String,
      default: '#0018F0'
    }
  },
  computed: {
    searchTargetList () {
      return pageNameMapper
    }
  },
  methods: {
    toSupportPage () {
      window.open('https://support.b-cms.jp', '_blank')
    }
  }
}
</script>
